// PARSE THE RETURNED JSON STATION DATA & PUSH INTO ARRAY
export const parsePetrolPriceData = petrolPriceJsonData => {
	const parsedPetrolPriceData = [];

	petrolPriceJsonData.stations.forEach(function (stations, i) {
		try {
			const stationData = JSON.parse(stations);
			parsedPetrolPriceData.push(stationData);
		} catch (error) {
			// Handle the JSON parsing error, e.g., log the error or ignore the entry
			console.error(`Error parsing JSON at index ${i}: ${error.message}`);
		}
	});

	return parsedPetrolPriceData;
};

// SORT PARSEDPETROLPRICEDATA. SLICE(0) CREATES NEW ARRAY FROM ARRAY TO SORT ON, 1 - BY PRICE, 2 BY DISTANCE
export const sortPetrolPriceData = (parsedPetrolPriceData, sortType, sortedPetrolPriceData) => {
	if (parsedPetrolPriceData.length > 1) {
		sortedPetrolPriceData = parsedPetrolPriceData.slice(0);
		switch (sortType) {
			case 'price':
				sortedPetrolPriceData = sortedPetrolPriceData.sort((a, b) => {
					if (a.ModalPrice !== b.ModalPrice) {
						return a.ModalPrice - b.ModalPrice;
					}
					return a.Distance - b.Distance;
				});
				break;

			case 'distance':
				sortedPetrolPriceData = sortedPetrolPriceData.sort((a, b) => {
					if (a.Distance !== b.Distance) {
						return a.Distance - b.Distance;
					}
					return a.ModalPrice - b.ModalPrice;
				});
				break;
			default:
				break;
		}
	} else {
		sortedPetrolPriceData = parsedPetrolPriceData;
	}
	return sortedPetrolPriceData;
};

// FILTER FOR ONLY CURRENTLY OPEN STATIONS OR ALL
export const filterData = (filterOnlyOpenCheckbox, sortedPetrolPriceData, displayData) => {
	if (filterOnlyOpenCheckbox.checked) {
		const filterOnlyOpenData = sortedPetrolPriceData.filter(function (e) {
			return e.IsOpen === true;
		});
		displayData = filterOnlyOpenData;
	} else {
		displayData = sortedPetrolPriceData;
	}
	return displayData;
};
